export const typography = {
  fontFamily: 'Figtree, Arial, Helvetica, sans-serif',
} as const;
